<template>
  <CLoading :loading="loading" />
  <q-table
    bordered
    flat
    dense
    title="Treats"
    ref="welcomeList"
    v-if="initials"
    :rows="initials"
    row-key="title"
    :rows-per-page-options="[10]"
    separator="cell"
    :no-data-label="$t('messages.no_data_available')"
    class="text-grey-8"
  >
    <template v-slot:header="props">
      <q-tr>
        <!-- <q-th key="action" rowspan="2" class="text-center" style="width: 50px">
          <span class="text-bold">{{ $t('label.prod') }}</span></q-th
        >
        <q-th key="action" rowspan="2" class="text-center" style="width: 50px">
          <span class="text-bold">{{ $t('label.test') }}</span></q-th
        > -->
        <q-th key="action" rowspan="2" class="text-center" style="width: 100px"></q-th>
        <q-th :props="props" key="title" rowspan="2">
          <span class="text-bold">{{ $t('label.initial.campaign_name') }}</span>
        </q-th>
        <q-th :props="props" key="stories_using_this_initial" rowspan="2">
          <span class="text-bold">{{ $t('label.initial.number_story') }}</span>
        </q-th>
        <q-th :props="props" key="delivered" rowspan="2">
          <span class="text-bold">{{ $t('label.initial.delivered') }}</span>
        </q-th>

        <q-th :props="props" key="total_user_of_goal" rowspan="2">
          <span class="text-bold">{{ $t('label.total_user_of_goal') }}</span>
        </q-th>
        <q-th :props="props" key="gtr" rowspan="2">
          <span class="text-bold">GTR</span>
        </q-th>
        <q-th :props="props" key="total_click" rowspan="2">
          <span class="text-bold">{{ $t('label.total_click') }}</span>
        </q-th>
        <q-th :props="props" key="success_rate" rowspan="2">
          <span class="text-bold">CVR</span>
        </q-th>
        <q-th :props="props" key="success_count" rowspan="2">
          <span class="text-bold">CV</span>
        </q-th>
      </q-tr>
    </template>
    <template v-slot:body="props">
      <q-tr :props="props" :index="props.rowKey">
        <!-- <q-td>
          <q-toggle
            round
            v-model="props.row.is_active"
            val="props.row.is_active"
            @click="handleToggleActive(props.row)"
            :disable="!!props.row.story_id"
          />
        </q-td>
        <q-td>
          <q-toggle
            round
            v-model="props.row.is_test_mode"
            val="props.row.is_test_mode"
            @click="handleToggleTest(props.row)"
            :disable="!!props.row.story_id"
          />
        </q-td> -->
        <q-td key="action" :props="props.index">
          <q-btn size="sm" flat round icon="edit" :to="onEdit(props.row)" class="q-mr-xs btn-custom" />
          <app-copy-button @click="onCopy(props.row)" class="q-mr-xs" />
          <q-btn
            size="sm"
            flat
            round
            color="red"
            icon="mdi-trash-can"
            @click="onDelete(props.row)"
            class="q-mr-xs"
            :disable="props.row.stories_using_this_initial > 0"
          />
        </q-td>
        <q-td key="title" :props="props">
          {{ props.row.title }}<br />
          <a
            :href="getDetailsUrl(props.row)"
            @click="onDetails($event, props.row)"
            class="cursor-pointer hyper-link-chart"
          >
            {{ $t('label.data_transition') }}
          </a>
          <span>/{{ props.row._id.length > 4 ? props.row._id.slice(0, 4) + '***' : props.row._id }}</span>
        </q-td>
        <q-td key="stories_using_this_initial" :props="props">
          <span class="cursor-pointer hyper-link-chart" @click="onOpenUsageStoryModal(props.row._id)">
            {{ numberWithCommas(props.row.stories_using_this_initial) }}
          </span>
        </q-td>
        <q-td key="delivered" :props="props">
          {{ numberWithCommas(props.row.delivered) }}
        </q-td>
        <q-td key="date_picker" :props="props">
          {{ toLocalTime(props.row.date_picker) || '-' }}
        </q-td>
        <q-td key="total_user_of_goal" :props="props">
          {{ numberWithCommas(props.row.total_user_of_goal) }}
        </q-td>
        <q-td key="gtr" :props="props"> {{ roundNumber(props.row.gtr) }}% </q-td>
        <q-td key="total_click" :props="props">
          {{ numberWithCommas(props.row.total_click) }}
        </q-td>
        <q-td key="success_rate" :props="props"> {{ roundNumber(props.row.success_rate) }}% </q-td>
        <q-td key="success_count" :props="props">
          {{ numberWithCommas(props.row.success_count) }}
        </q-td>
      </q-tr>
    </template>

    <template v-slot:top>
      <h2 class="text-h6 q-mr-md text-black">{{ $t('label.initial.initial_campaign_list') }}</h2>
      <DateRangeSelectorV2
        v-model="dateRange"
        :disable="false"
        @update:onChangeDateRange="changeDateRange"
      ></DateRangeSelectorV2>
      <q-space />
      <q-select
        outlined
        dense
        clearable
        multiple
        option-value="_id"
        option-label="target_name"
        v-model="selectedTargetIds"
        :options="targetSettings"
        emit-value
        map-options
        class="q-ma-md"
        style="width: 240px"
        :label="$t('label.target_setting.target_setting')"
      />
      <q-btn v-if="scenario_templates.length > 0" no-caps class="btn-save" :label="$t('add_new')">
        <q-menu>
          <q-list dense style="min-width: 200px">
            <q-item clickable v-close-popup @click="onAdd(0)">
              <q-item-section>{{ $t('create_new') }}</q-item-section>
            </q-item>
            <q-item clickable>
              <q-item-section>{{ $t('from_template') }}</q-item-section>
              <q-menu anchor="top end" self="top start">
                <q-list style="min-width: 200px">
                  <q-item
                    v-for="(template, index) in scenario_templates"
                    :key="index"
                    dense
                    clickable
                    @click="onAdd(template._id)"
                  >
                    <q-item-section>{{ template.title }}</q-item-section>
                  </q-item>
                </q-list>
              </q-menu>
            </q-item>
          </q-list>
        </q-menu>
      </q-btn>
      <q-btn v-else no-caps class="btn-save" @click="onAdd(0)" :label="$t('add_new')" />
    </template>
  </q-table>

  <UsageStoryModal
    v-if="usageStoryModalVisible"
    :modalVisible="usageStoryModalVisible"
    :campaignId="initialId"
    :campaignType="'initial'"
    @update:closeModal="onCloseUsageStoryModal"
  />
</template>

<script lang="ts">
import { mixins, Options } from 'vue-class-component'
import { maska } from 'maska'
import { IDateRangePicker, IInitialCampaign, IScenarioTemplate, ITargetSetting } from '@/utils/types'
import { Watch } from 'vue-property-decorator'
import { ACTION_INITIAL, ACTION_SCENARIO_TEMPLATE, ACTION_TARGET_SETTING } from '@/store/actions'
import { constant } from '@/utils/constants'
import { Formater } from '@/utils/formater'
import cloneDeep from 'lodash/cloneDeep'
import InitialCampaignMixin from './mixins/InitialCampaignMixin.vue'
import CLoading from '@/components/common/ui/CLoading.vue'
import DateRangeSelectorV2 from '@/components/common/ui/DateRangeSelectorV2.vue'
import { DatetimeUtils } from '@/utils/datetime'
import BaseFormMixin from '../common/mixins/BaseFormMixin.vue'
import UsageStoryModal from '@/components/story/UsageStoryModal.vue'

@Options({
  components: { UsageStoryModal, CLoading, DateRangeSelectorV2 },
  directives: { maska },
  emits: [],
})
export default class InitialCampaignList extends mixins(InitialCampaignMixin, BaseFormMixin) {
  initials: IInitialCampaign[] = []
  scenario_templates: IScenarioTemplate[] = []
  loading = true
  usageStoryModalVisible = false
  initialId = ''

  dateRange: IDateRangePicker = {
    startDate: '',
    endDate: '',
  }

  selectedTargetIds = ['all']

  get initial_lists() {
    return this.initials
  }

  get targetSettings() {
    let result: ITargetSetting[] = []
    const all: ITargetSetting = {
      _id: 'all',
      app_id: this.selectedAppId,
      target_name: this.$t('label.all'),
    }

    result.push(all)
    result = result.concat(this.$store.getters.targetSettings)
    return result
  }

  @Watch('$store.getters.initials')
  initialChanged() {
    const getInitials = cloneDeep(this.$store.getters.initials)
    if (getInitials) {
      return (this.initials = getInitials)
    }
  }

  @Watch('$store.getters.scenarioTemplates')
  scenarioTemplateChanged() {
    const getScenarios = cloneDeep(this.$store.getters.scenarioTemplates)
    if (getScenarios) {
      return (this.scenario_templates = getScenarios)
    }
  }

  @Watch('selectedAppId', { immediate: true })
  async appIdChanged() {
    if (!this.selectedAppId) {
      return
    }

    this.dateRange = DatetimeUtils.getDateRange('last30Days')
    await this.loadIntials()
  }

  @Watch('selectedTargetIds')
  handleChangeTargetSetting() {
    if (this.selectedTargetIds === null || this.selectedTargetIds.length === 0) {
      this.selectedTargetIds = ['all']
    }
    this.loadIntials()
  }

  async loadIntials() {
    this.loading = true

    await this.$store.dispatch(ACTION_TARGET_SETTING.LOAD_ITEMS_WITHOUT_DETAIL, {
      app_id: this.selectedAppId,
    })

    await this.$store.dispatch(ACTION_INITIAL.LOAD_ITEMS_SUMMARY, {
      app_id: this.selectedAppId,
      date_from: DatetimeUtils.formatDate(this.dateRange.startDate),
      date_to: DatetimeUtils.formatDate(this.dateRange.endDate),
      target_setting_ids: this.selectedTargetIds,
    })

    await this.$store.dispatch(ACTION_SCENARIO_TEMPLATE.LOAD_ITEMS_WITHOUT_DETAIL, {
      app_id: this.selectedAppId,
    })

    this.loading = false
  }

  // async updateIsActive(item: IInitialCampaign, isTestMode: boolean) {
  //   let isSuccess = false
  //   if (isTestMode) {
  //     isSuccess = await this.$store.dispatch(ACTION_INITIAL.TEST_MODE, item)
  //   } else {
  //     isSuccess = await this.$store.dispatch(ACTION_INITIAL.IS_ACTIVE, item)
  //   }

  //   if (isSuccess) {
  //     this.$q.notify({
  //       message: this.$t('messages.saved'),
  //       color: 'positive',
  //     })
  //   }

  //   return isSuccess
  // }

  // async handleToggleActive(record: IInitialCampaign) {
  //   if (record.story_id) {
  //     return
  //   }
  //   if (record.is_active) {
  //     let message = ''
  //     const initial: IInitialCampaign = await this.$store.dispatch(ACTION_INITIAL.LOAD_ITEM, record._id)
  //     console.log(initial, 'initial')
  //     if (
  //       initial &&
  //       (initial._id === '' || initial._id === undefined || initial.prod_detail?.scenarios?.length === 0)
  //     ) {
  //       message = this.$t('messages.display_an_alert_prompting_the_user_to_create_a_message')
  //     }

  //     const scenarios = initial.prod_detail?.scenarios
  //     if (scenarios) {
  //       for (const element of scenarios) {
  //         if (element.id !== 'start' && element.id === '') {
  //           message = this.$t('messages.display_an_alert_prompting_the_user_to_create_a_message')
  //           break
  //         }
  //       }
  //     }
  //     if (message === '') {
  //       const resp = await this.$store.dispatch(ACTION_STORY.VALIDATE_DEFAULT_TYPE, {
  //         app_id: record.app_id,
  //         is_test_mode: false,
  //       })
  //       // eslint-disable-next-line
  //       if (resp && resp['result']) {
  //         message = this.$t('messages.display_an_alert_that_only_one_can_be_active')
  //       }
  //     }
  //     if (message !== '') {
  //       this.$q.dialog({
  //         title: 'ご確認下さい',
  //         message: message,
  //         persistent: true,
  //         html: true,
  //         class: 'q-dialog-plugin-custom',
  //       })

  //       record.is_active = false
  //       return
  //     }
  //   }

  //   if (!record.is_active) {
  //     this.updateIsActive(record, false)
  //   } else {
  //     this.$q
  //       .dialog({
  //         title: this.$t('messages.confirm'),
  //         message: this.$t('messages.are_you_sure_to_turn_on_active_for_this_item'),
  //         cancel: {
  //           flat: true,
  //           label: this.$t('messages.no'),
  //         },
  //         ok: {
  //           flat: true,
  //           label: this.$t('messages.yes'),
  //         },
  //         persistent: true,
  //       })
  //       .onOk(async () => {
  //         this.updateIsActive(record, false)
  //       })
  //       .onCancel(async () => {
  //         record.is_active = false
  //       })
  //   }
  // }

  // async handleToggleTest(record: IInitialCampaign) {
  //   if (record.story_id) {
  //     return
  //   }
  //   if (record.is_test_mode) {
  //     let message = ''
  //     const initial: IInitialCampaign = await this.$store.dispatch(ACTION_INITIAL.LOAD_ITEM, record._id)
  //     console.log(initial, 'initial')
  //     if (
  //       initial &&
  //       (initial._id === '' || initial._id === undefined || initial.test_detail?.scenarios?.length === 0)
  //     ) {
  //       message = this.$t('messages.display_an_alert_prompting_the_user_to_create_a_message')
  //     }

  //     const scenarios = initial.test_detail?.scenarios
  //     if (scenarios) {
  //       for (const element of scenarios) {
  //         if (element.id !== 'start' && element.id === '') {
  //           message = this.$t('messages.display_an_alert_prompting_the_user_to_create_a_message')
  //           break
  //         }
  //       }
  //     }
  //     if (message === '') {
  //       const resp = await this.$store.dispatch(ACTION_STORY.VALIDATE_DEFAULT_TYPE, {
  //         app_id: record.app_id,
  //         is_test_mode: true,
  //       })
  //       // eslint-disable-next-line
  //       if (resp && resp['result']) {
  //         message = this.$t('messages.display_an_alert_that_only_one_can_be_active')
  //       }
  //     }
  //     if (message !== '') {
  //       this.$q.dialog({
  //         title: 'ご確認下さい',
  //         message: message,
  //         persistent: true,
  //         html: true,
  //         class: 'q-dialog-plugin-custom',
  //       })

  //       record.is_test_mode = false
  //       return
  //     }
  //   }

  //   this.updateIsActive(record, true)
  // }

  onAdd(scenario_template_id) {
    if (scenario_template_id) {
      this.goto('initial_setting', {
        app_id: this.selectedAppId,
        action_type: constant.ACTION_TYPE.ADD,
        scenario_template_id: scenario_template_id,
      })
    } else {
      this.goto('initial_setting', { app_id: this.selectedAppId, action_type: constant.ACTION_TYPE.ADD })
    }
  }

  onEdit(data: IInitialCampaign) {
    return this.detailPath('initial_setting', {
      app_id: this.selectedAppId,
      initial_id: data._id,
      action_type: constant.ACTION_TYPE.EDIT,
    })
  }

  onDetails(event, data: IInitialCampaign) {
    // Check if Ctrl (Windows) or Meta (Mac) is pressed
    if (event.ctrlKey || event.metaKey) {
      // Let the browser handle opening in a new tab
      return
    }
    // Otherwise, navigate programmatically
    event.preventDefault()

    this.goto('initial_details', {
      app_id: this.selectedAppId,
      campaign_type: 'initial',
      campaign_id: data._id,
      from_date: DatetimeUtils.formatDate(this.dateRange.startDate),
      to_date: DatetimeUtils.formatDate(this.dateRange.endDate),
    })
  }

  getDetailsUrl(data) {
    // Construct the URL as a string for direct navigation
    return this.$router.resolve({
      name: 'initial_details',
      params: {
        app_id: this.selectedAppId,
        campaign_type: 'initial',
        campaign_id: data._id,
        from_date: DatetimeUtils.formatDate(this.dateRange.startDate),
        to_date: DatetimeUtils.formatDate(this.dateRange.endDate),
      },
    }).href
  }

  numberWithCommas(num) {
    return Formater.numberFormat(num)
  }

  roundNumber(num) {
    return Formater.round(num)
  }

  changeDateRange(value) {
    this.dateRange = value

    this.loadIntials()
  }

  onOpenUsageStoryModal(id) {
    this.initialId = id
    this.usageStoryModalVisible = true
  }

  onCloseUsageStoryModal() {
    this.usageStoryModalVisible = false
  }
}
</script>
<style lang="scss" scoped>
span.hyper-link-chart {
  color: #4956e3;
  text-decoration: underline;
}
</style>
